import axios from 'axios'
import Cookies from 'js-cookie'

const API_URL = process.env.REACT_APP_API_URL

export const logEvent = async ({ action, content }) => {
  const token = Cookies.get('token')

  if (token) {
    try {
      await axios.post(
        `${API_URL}/logs/behavior`,
        {
          action,
          content,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
    } catch (err) {
      console.error('Failed to log event:', err)
    }
  }
}
